import React,{useEffect,useState} from 'react';
import Bottom_menu from './Bottom_menu';
import DatePicker, { registerLocale } from "react-datepicker";
import ko from "date-fns/locale/ko";
import calendar from './img/sigong_nav/month.png'
import {comma,formatDate,instance} from './common'
import right from './img/right icon.png'
import Pagination from "react-js-pagination";
import newJugan from './img/newJugan.png'



function totalPrice(data) {
    let price = 0;
    JSON.parse(data).forEach(function (v) {
      if(v.is_check == 1){
        price += Number(v.daeri_price) * v.pr_count;
      }
    });
    return comma(price);
}

function nameMake(data){
    let name = '';
    let cnt = 0;
    JSON.parse(data).forEach(function (v) {
      if(v.is_check == 1){
        if(cnt == 0){
          name = v.pr_name;
        }
        cnt++;
        
      }
    });
  
    if(cnt > 1){
      let nowCount = cnt-1;
      name = name + ' 외 ' + (nowCount) + '개';
    }
  
    return name;
}

function ProductManage({history}){

    const ab = {
        position:'absolute',
        right:'23px',
        top:'4px',
        width:'20px'
    }

    const ab2 = {
        position:'absolute',
        right:'8px',
        top:'4px',
        width:'20px'
    }

    const [headTab , setHeadTab] = useState('상품관리');

    const headChange = (e) => {
        const {tab} = e.target.dataset;
        setHeadTab(tab);
        if(tab === '상품관리'){
            setType('YEAR');
            setValue('-1');
        }else{
            setType('');
            setValue('');
        }
        setStartDate('');
        setEndDate('');
        
    }
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const startChange = (date) => {
        setStartDate(date);
    }
    const endChange = (date) => {
        setEndDate(date);
        setType('');
        setValue('');
    }


    const [data, setData] = useState([]);
    const [jaego, setJaego] = useState([]);
    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [p_status, setStatus] = useState('');

    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const {u_id} = parsedsigong;
    
    const [dateType, setType] = useState('YEAR');
    const [dateValue, setValue] = useState('-1');
    
    useEffect(() => {

         
        let obj = {
            page: page,
            ppp: ppp,
            p_u_id:u_id,
            p_status:p_status,
            dateType:dateType,
            dateValue:dateValue,
            start:startDate && formatDate(startDate),
            end:endDate && formatDate(endDate),
        }
        
        const fetchData = async () => {
          instance.post('/purchase/my-list', obj).then(function (res) {
            setData(res.data.rows);
            setTotal(res.data.totalCount);
          });

          instance.post('/jaego/my-list', obj).then(function (res) {
            setJaego(res.data.rows);
          });


    
        };
    
        fetchData();
    
      }, [p_status,dateType,dateValue,startDate,endDate]);
      

      const onChange = (e) => {
          const {name,value} = e.target;
          setStatus(value);
      }

      const pageChange = (pageNumber) => {
        setPage(pageNumber);
      }

      const tabChange = (e) => {
        const {type,value} = e.target.dataset;
        setStartDate('');
        setEndDate('');
        setType(type);
        setValue(value);
      }
      

    return (
        <>
        <div className="container text-center pt-5">
            <div className="row border-bottom p-0">
                {
                    headTab === '상품관리'
                    ?<div className="product-tab active col pt-2 pb-2" onClick={headChange} data-tab="상품관리">상품관리</div>
                    :<div className="product-tab col pt-2 pb-2" onClick={headChange} data-tab="상품관리">상품관리</div>
                }
                {
                    headTab === '재고관리'
                    ?<div className="product-tab active col pt-2 pb-2" onClick={headChange} data-tab="재고관리">재고관리</div>
                    :<div className="product-tab col pt-2 pb-2" onClick={headChange} data-tab="재고관리">재고관리</div>
                }
                
            </div>
            {
                headTab === '상품관리'
                ?
                <>
                <div className="row p-0 mt-4">
                    {
                        (dateType === 'YEAR' && dateValue === '-1')
                        ?<div className="product-date-tab active col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="YEAR" data-value="-1">최근1년</div>
                        :<div className="product-date-tab col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="YEAR" data-value="-1">최근1년</div>
                    }
                    {
                        (dateType === 'WEEK' && dateValue === '-1')
                        ?<div className="product-date-tab active col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="WEEK" data-value="-1">1주일</div>
                        :<div className="product-date-tab col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="WEEK" data-value="-1">1주일</div>
                    }
                    {
                        (dateType === 'MONTH' && dateValue === '-1')
                        ?<div className="product-date-tab active col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-1">1개월</div>
                        :<div className="product-date-tab col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-1">1개월</div>
                    }
                    {
                        (dateType === 'MONTH' && dateValue === '-3')
                        ?<div className="product-date-tab active col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-3">3개월</div>
                        :<div className="product-date-tab col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-3">3개월</div>
                    }
                    {
                        (dateType === 'MONTH' && dateValue === '-6')
                        ?<div className="product-date-tab active col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-6">6개월</div>
                        :<div className="product-date-tab col pt-2 pb-2 pl-0 pr-0" onClick={tabChange} data-type="MONTH" data-value="-6">6개월</div>
                    }
                </div>

                <div className="row mt-4 mb-4 pl-0 pr-0">
                    <div className="pl-0 col-6" style={{position:'relative'}}>
                        <DatePicker
                            locale="ko"
                            dateFormat="yyyy-MM-dd"
                            className="progress-datepicker form-control text-center text-primary culDate"
                            selected={startDate}
                            onChange={startChange}
                        />
                        <img src={calendar} style={ab}/>
                    </div>
                    <div className="pr-0 col-6" style={{position:'relative'}}>
                        <DatePicker
                            locale="ko"
                            dateFormat="yyyy-MM-dd"
                            className="progress-datepicker form-control text-center text-primary culDate"
                            selected={endDate}
                            onChange={endChange}
                        />
                        <img src={calendar} style={ab2}/>
                    </div>
                </div>
                <hr></hr>
                <select name="p_status" className="form-control w-25" onChange={onChange}>
                    <option value="">전체</option>
                    <option value="결제">결제</option>
                    <option value="배송완료">배송완료</option>
                </select>

                {
                    data.map(v => 
                        <div key={v.p_id} className="row pl-0 pr-0 border mt-3" style={{position:'relative'}} onClick={() => history.push('/order-page?o_id='+v.p_number)}>
                            <div className="col-12 text-left pt-3">
                                <h4 className="font-weight-bold d-inline-block mr-3">주문번호 : {v.p_number}</h4>
                                <span className="font-weight-bold" style={{color:v.p_status === '결제' ? 'red' : '2F79D9'}}>{v.p_status}</span>
                                <h4 className="font-weight-bold mb-0">주문일 : {v.or_date}</h4>
                                <hr></hr>
                                <img src={right} style={{...ab2,top:'20px'}}/>
                            </div>
                            <div className="col-6 text-left pb-3">
                                <h4 className="font-weight-bold mb-0">{nameMake(v.p_pr_id)}</h4>
                            </div>
                            <div className="col-6 text-right pb-3">
                                <h4 className="font-weight-bold mb-0">{comma(totalPrice(v.p_pr_id))} 원</h4>
                            </div>
                        </div>

                    )
                }

            

                </>
                : //재고관리
                <>
                <div className="row p-0 mt-4">
                    <div className="col-6 pl-0 text-left">
                        <select className="form-control d-inline-block" style={{width:'auto'}}>
                            <option>재고순</option>
                        </select>
                    </div>
                    <div className="col-6 pr-0 text-right">
                        <span className="btn btn-primary" onClick={() => history.push('/product')}>상품 주문하기</span>
                    </div>
                </div>
                <div className="row p-0 mt-4">
                    {
                        jaego.map(v => 
                            <>
                            <div className="pl-0 col-3"  style={{position:'relative'}}>
                                <div className="jaego-box" style={{background:'url(\''+v.pr_img+'\')'}}></div>
                            </div>
                            <div className="col-7 jaego-box-title text-left">
                                <h4 className="font-weight-bold">{v.pr_name}</h4>
                                <h5 className="jaego-count font-weight-bold">재고 {v.pr_count} 개</h5>
                            </div>
                            <div className="col-2 pl-0 pr-0">
                                <span className="quality-span text-primary" style={{fontSize:'10px',wordBreak:'keep-all'}} onClick={() => history.push('/quality-list?jae_id='+v.jae_id)}>품질보증현황</span>
                            </div>
                            
                            <hr className="w-100"></hr>
                            </>
                        )
                    }
                    
                </div>
                </>
                
            }
                <div className="text-center">
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={10}
                        totalItemsCount={total}
                        pageRangeDisplayed={10}
                        onChange={pageChange}
                    />
                </div>
            
        </div>

        <Bottom_menu />
        </>
    )
}

export default ProductManage;